import { ISidebarItem } from './sidebar.interface';

export const SIDEBAR_ROUTES: ISidebarItem[] = [
  {
    path: 'home',
    title: 'Dashboard',
    icon: 'fa-tachometer-alt',
  },
  {
    path: 'accounts',
    title: 'Accounts',
    icon: 'far fa-address-card',
    isCollapsed: false,
    avilableFor: ['Accounts', 'Read-Only Accounts', 'Client Admin - Accounts'],
    subMenu: [
      {
        path: 'provider-groups',
        title: 'Providers Group',
        icon: 'group',
        avilableFor: [
          'Accounts',
          'Read-Only Accounts',
          'Client Admin - Accounts',
        ],
      },
      {
        path: 'providers',
        title: 'Providers',
        icon: 'fas fa-user-md',
        avilableFor: [
          'Accounts',
          'Read-Only Accounts',
          'Client Admin - Accounts',
        ],
      },
    ],
  },
  {
    path: 'claims',
    title: 'Claims',
    icon: 'far fa-file-alt',
    avilableFor: ['Claims'],
    subMenu: [
      {
        path: 'claims-archive',
        title: 'Claims Archive',
        icon: 'far fa-file-alt',
        avilableFor: ['Claims'],
      },
    ],
  },
  {
    path: 'era',
    title: 'ERA',
    icon: 'fas fa-file-invoice-dollar',
    avilableFor: ['ERA'],
  },
  {
    path: 'financial',
    title: 'Financial',
    icon: 'fa-landmark',
    isCollapsed: false,
    avilableFor: ['Financial Module', 'Read Only - Financial Module'],
    subMenu: [
      {
        path: 'client-search',
        title: 'Client Search',
        icon: 'fa-address-book',
        avilableFor: ['Financial Module', 'Read Only - Financial Module'],
      },
      {
        path: 'payment-analytics',
        title: 'Payment Analytics',
        icon: 'fa-balance-scale',
        avilableFor: ['Financial Module', 'Read Only - Financial Module'],
      },
      {
        path: 'payments-view',
        title: 'View Payments',
        icon: 'fa-dollar-sign',
        avilableFor: ['Financial Module', 'Read Only - Financial Module'],
      },
    ],
  },
  {
    path: 'group-enrollments',
    title: 'Group Enrollments',
    icon: 'fas fa-tasks',
    avilableFor: ['Group Enrollments'],
  },
  {
    path: 'payers',
    title: 'Payer',
    icon: 'fas fa-file-medical',
    isCollapsed: false,
    avilableFor: ['Payer'],
    subMenu: [
      {
        path: 'insurances',
        title: 'Insurance',
        icon: 'fas fa-id-card-alt',
        avilableFor: ['Insurance'],
      },
      {
        path: 'eligibility-routing',
        title: 'Eligibility Routing',
        icon: 'fa-users-cog',
        avilableFor: ['Eligibility Routing'],
      },
      {
        path: 'claims-status-routing',
        title: 'Claims Status Routing',
        icon: 'fa-file-invoice-dollar',
        avilableFor: ['Claim Status Routing'],
      },
    ],
  },
  {
    path: 'payer-information',
    title: 'Payer Information',
    icon: 'fa fa-compass',
    //avilableFor: ['Payer']
  },
  {
    path: 'users',
    title: 'Users',
    icon: 'fa-users',
    avilableFor: ['Users'],
  },
  {
    path: 'utilities',
    title: 'Utilities',
    icon: 'fa-cog',
    avilableFor: ['Utilities'],
  },
];
